<template>
  <div>
    <el-input v-model="jigouname" placeholder="点击选择机构" @click.native="displaydialog = true"></el-input>
    <!-- 所属机构弹出提示框 -->
    <el-dialog title="请选所属择机构" :visible.sync="displaydialog" width="30%" :close-on-click-modal="true">
      <!-- 头部搜索 start -->
      <el-form :inline="true" :model="searchjigou" class="demo-form-inline">
          <el-form-item label="选择机构: ">
              <el-input v-model="searchjigou.keywords" placeholder="请输入关键词"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="clicksearch(searchjigou.keywords)">搜索</el-button>
          </el-form-item>
      </el-form>
      <!-- 头部搜索 end -->
      <el-tree
        :data="jigoutreedata"
        :highlight-current="true"
        :default-expand-all="true"
        :expand-on-click-node="false"
        node-key="id"
        ref="tree"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogclean">清 空</el-button>
        <!-- <el-button @click="dialogcancel">取 消</el-button> -->
        <el-button type="primary" @click="dialogok">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 所属机构弹出提示框 end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  props: {
  	propsjigouid: {
  		type: String,
  		default: ''
  	},
  	propsjigouname: {
  		type: String,
  		default: ''
  	}
  },
  data () {
    return {
      jigouid: this.propsjigouid,
      jigouname: this.propsjigouname,
      searchjigou: {
        keywords: ''
      },
      jigoutreedata: [],
      displaydialog: false
    }
  },
  mounted () {
    this.apigetjigoutree()
  },
  watch: {
    propsjigouid (newVal) {
      this.jigouid = newVal
    },
    propsjigouname (newVal) {
      this.jigouname = newVal
    }
  },
  methods: {
    dialogclean () {
      this.searchjigou.keywords = ''
      this.apigetjigoutree()

      this.jigouid = 0
      this.jigouname = ''
      this.displaydialog = false
      this.$emit('change', this.jigouid, this.jigouname)
    },
    dialogcancel () {
      this.displaydialog = false
    },
    dialogok () {
      var nodebuf = this.$refs.tree.getCurrentNode()
      if (nodebuf) {
        this.jigouid = nodebuf.id
        this.jigouname = nodebuf.label
      } else {
        this.jigouid = 0
        this.jigouname = ''
      }
      this.displaydialog = false
      this.$emit('change', this.jigouid, this.jigouname)
    },
    clicksearch (keyword) {
      if (keyword.length === 0) {
        this.apigetjigoutree()
      } else {
        this.apigetjigoutreesmall(keyword)
      }
    },
    apigetjigoutree: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        companytype: '0'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getjigoutree, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.jigoutreedata = []
            response.data.List.filter((item1, i1) => {
              var list2 = []
              item1.List.filter((item2, i2) => {
                var list3 = []
                item2.List.filter((item3, i3) => {
                  var list4 = []
                  item3.List.filter((item4, i4) => {
                    var list5 = []
                    item4.List.filter((item5, i5) => {
                      list5.push({ id: item5.Id, label: item5.Jigouname, children: '' })
                    })
                    if (list5.length == 0) list5 = ''
                    list4.push({ id: item4.Id, label: item4.Jigouname, children: list5 })
                  })
                  if (list4.length == 0) list4 = ''
                  list3.push({ id: item3.Id, label: item3.Jigouname, children: list4 })
                })
                if (list3.length == 0) list3 = ''
                list2.push({ id: item2.Id, label: item2.Jigouname, children: list3 })
              })
              if (list2.length == 0) list2 = ''
              that.jigoutreedata.push({ id: item1.Id, label: item1.Jigouname, children: list2 })
            })
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetjigoutreesmall: function (keyword) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        keyword: keyword,
        companytype: '0'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getjigoutreesmall, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.jigoutreedata = []
            response.data.List.filter((item1, i1) => {
              that.jigoutreedata.push({ id: item1.Id, label: item1.Jigouname, children: '' })
            })
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree {
  height: 350px;
  overflow-y: scroll;
}
.el-tree::-webkit-scrollbar {
  display: none;
}
</style>
